import { action } from '@ember/object';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import tippy from 'tippy.js';

export default class MoleculesArchiveMenuComponent extends Component {
  @service router;
  @service store;
  tippyInstance;
  tippyHover;
  @tracked isOpen = false;

  constructor() {
    super(...arguments);
  }

  get showUncertainties() {
    return this.args.team?.show_uncertainties || false;
  }

  get showWfas() {
    return this.args.team?.show_wfa || false;
  }

  @action
  handleKeyup(e) {
    if (e.keyCode === 27) {
      this.closeMenu();
    }
  }

  @action
  initiateTippies(element) {
    this.createTippy(element);
    this.hoverTippy(element);
  }

  @action
  createTippy(element) {
    let tigger = element;
    let dropdown = element.querySelector('.tippy-archive-dropdown');
    let self = this;
    this.tippyInstance = tippy(tigger, {
      content: dropdown,
      placement: 'bottom',
      arrow: false,
      trigger: 'click',
      interactive: true,
      offset: [0, 8],
      onShow() {
        self.isOpen = true;
      },
      onHide() {
        self.isOpen = false;
      },
    });
  }

  @action
  hoverTippy(element) {
    let tigger = element;
    let dropdown = element.querySelector('.tippy-dropdown');
    this.tippyHover = tippy(tigger, {
      content: dropdown,
      placement: 'bottom',
      arrow: false,
      trigger: 'mouseenter',
      interactive: false,
      offset: [-6, 8],
    });
  }

  @action
  closeMenu() {
    this.tippyInstance.hide();
    this.isOpen = false;
  }

  @action
  questionArchive() {
    this.router.transitionTo(
      'operations.teams.team.check-in.archive.questions',
    );
    this.closeMenu();
  }

  @action
  llArchive() {
    this.router.transitionTo(
      'operations.teams.team.check-in.archive.lessons-learned',
    );
    this.closeMenu();
  }

  @action
  tfoArchive() {
    this.router.transitionTo(
      'operations.teams.team.check-in.archive.to-figure-outs',
    );
    this.closeMenu();
  }

  @action
  wfaArchive() {
    this.router.transitionTo(
      'operations.teams.team.check-in.archive.waiting-for-answers',
    );
    this.closeMenu();
  }

  @action
  uncertaintiesArchive() {
    this.router.transitionTo(
      'operations.teams.team.check-in.archive.uncertainties',
    );
    this.closeMenu();
  }

  @action
  async archiveAll() {
    let team = this.args.team;
    let questions = await team.get('questions');
    let lls = await team.get('lls');
    let tfos = await team.get('tfos');
    let wfas = this.showWfas ? await team.get('wfas') : [];
    let uncertainties = this.showUncertainties
      ? await team.get('uncertainties')
      : [];

    const allItems = questions.concat(lls, tfos, wfas, uncertainties);
    allItems.forEach((item) => {
      // const modelName = item.get('constructor.modelName');
      // let peekItem = this.store.peekRecord(modelName, item.id);
      if (item.completed) {
        item.archived = true;
        item.save();
      }
    });
    this.closeMenu();
  }
}
